import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import * as SecuritySelectors from './state/selectors';
import { isPreferenceDisabled } from './SecurityHelpers';

class SecurityPreferences extends React.Component {
  static propTypes = {
    children: PropTypes.func.isRequired,
    scope: PropTypes.number.isRequired,
  };

  render() {
    const { children = () => {}, scope, preferences } = this.props;
    const disabled = isPreferenceDisabled(scope, preferences);

    return children(disabled);
  }
}

const mapStateToProps = state => ({
  preferences: SecuritySelectors.getPreferences(state),
});

SecurityPreferences = connect(mapStateToProps)(SecurityPreferences);

export { SecurityPreferences };



// WEBPACK FOOTER //
// ./src/common/Security/SecurityPreferences.js